import { GET_PROVIDENT_FUNDS } from './types';

export const getProvidentFundsRequest = (payload: any) => {
  return {
    type: GET_PROVIDENT_FUNDS.GET_PROVIDENT_FUNDS_REQUEST,
    payload: { payload },
  } as const;
};

export const getProvidentFundsSuccess = (data: any) => {
  return {
    type: GET_PROVIDENT_FUNDS.GET_PROVIDENT_FUNDS_SUCCESS,
    payload: {
      data,
    },
  } as const;
};

export const getProvidentFundsFailed = () => {
  return {
    type: GET_PROVIDENT_FUNDS.GET_PROVIDENT_FUNDS_FAILED,
  } as const;
};

export type ProvidentFundsActions =
  | ReturnType<typeof getProvidentFundsRequest>
  | ReturnType<typeof getProvidentFundsSuccess>
  | ReturnType<typeof getProvidentFundsFailed>;
